import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl,GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously} from "datasync-core";
import { globals} from "../Components/Globals/Globals";
import { produce } from 'immer';
const initialState = {
  hiringsItems: [],
  hiringCount: 0,
  loadHirings_result:{status: 'idle', error: null},
  deleteHiring_result:{status: 'idle', error: null},
  validateHirings_result:{status: 'idle', error: null, stat_email:null, stat_action:null},
}

// Create an async thunk for loading hirings
export const loadHirings = createAsyncThunk(
  'hirings/loadHirings',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.platform_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` true `, // Do not filter hirings
        table_guid: globals.datasync.pf_hirings_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadHirings::hirings response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting hirings
export const deleteHiring = createAsyncThunk(
  'hirings/deleteHiring',
  async (deletedHiringObject) => {
    try {
      console.clear()
      console.log("deletedHiringObject->", deletedHiringObject)
      //Delete hiring from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedHiringObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deleteHiring->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedHiringObject.rejectWithValue(error.message);
    }
  }
);

const hiringSlice = createSlice({
  name: 'hirings',
  initialState,
  reducers: {
    addHiring(state, action) {
      // New stat added 
      try {
        if (globals.parameters.debugging){
          console.log("addHiring: ", state.hiringsItems)
          console.log("addHiring: ", state.hiringCount)
          console.log("addHiring::action ->", action)  
        }
  
        state.hiringCount++;
        state.hiringsItems.push(action.payload);
      } catch (error) {
        console.error("Hiring added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel utilisateur en mémoire interne")
      }
    },

    updateHiring(state, action) {
      return produce(state, draft => {
        //Find former stat object to update
        const updatedHiringObject = draft.hiringsItems.find((hiring) => hiring.data_guid === action.payload.data_guid)
        console.log("updateHiring: updatedHiringObject->", updatedHiringObject)
        if (updatedHiringObject) {
          //update hiring in the array
          updatedHiringObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateHiring: Hiring not found in the array");
        }
      })
    },

    revertAllHirings(state){
      console.log("hiringSlice revertAllHirings");
      state.hiringsItems = [];
      state.hiringCount = 0;
      state.loadHirings_result = {status: 'idle', error: null};
      state.deleteHiring_result = {status: 'idle', error: null};
      state.validateHirings_result = {status: 'idle', error: null, stat_email:null, stat_action:null};
    },

    revertStatusHirings(state){
      if (globals.parameters.debugging)
        console.log("revertStatusHirings")

      state.deleteHiring_result = {status: 'idle', error: null};
      state.validateHirings_result = {status: 'idle', error: null, stat_email:null, stat_action:null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadHirings */
      .addCase(loadHirings.pending, (state, action) => {
        state.loadHirings_result = {status : "loading",error : null};
      })
      .addCase(loadHirings.fulfilled, (state, action) => {
        if (action.payload.length > 0) {
          state.loadHirings_result = {status : "succeeded",error : null};
          state.hiringsItems = action.payload;
          state.hiringCount= action.payload.length;
        }
        else {
          state.loadHirings_result = {status : "succeeded",error : "No hirings found !!!"};
          state.hiringsItems = [];
          state.hiringCount= 0;
        }
      })
      .addCase(loadHirings.rejected, (state, action) => {
        state.loadHirings_result = {status : "failed",error : action.payload};
      })

      /* deleteHiring */
      .addCase(deleteHiring.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteHiring.pending")
        console.log("deleteHiring.pending -> action", action)
        state.deleteHiring_result = {status : "deleting",error : null};
      })
      .addCase(deleteHiring.fulfilled, (state,action) => {
        //Hiring sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteHiring.fulfilled")
        console.log("deleteHiring.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete hiring from local state
          draft.hiringsItems = draft.hiringsItems.filter((hiring, j) => hiring.data_guid !== action.payload.data_guid)
          draft.hiringCount--;

          draft.deleteHiring_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteHiring.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteHiring.rejected")
          console.log("deleteHiring.rejected -> action", action)
        state.deleteHiring_result = {status : "failed",error : action.payload};
      })
  },
});

export const { addHiring, updateHiring, revertAllHirings, revertStatusHirings } = hiringSlice.actions;
export default hiringSlice.reducer;